import { proxy } from 'valtio'
import { devtools } from 'valtio/utils'

export interface GlobalLayoutProxyType {
  sidebarExpanded: boolean
  accountDropdownExpanded: boolean
}

export const globalLayoutProxy: GlobalLayoutProxyType = proxy({
  accountDropdownExpanded: false,
  sidebarExpanded: false
})

export function closeAccountDropdown (): void {
  globalLayoutProxy.accountDropdownExpanded = false
}

devtools(globalLayoutProxy, { name: 'globalLayout' })
